<script setup lang="ts">
import { ref } from 'vue'
import { Play } from 'lucide-vue-next'
import SiteFooter from '@/components/SiteFooter.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import VideoLightbox from '@/components/VideoLightbox.vue'
import { courseVideos, type DemoVideo as DemoVideoRecord } from '@/data/videoDemo'

const activeVideo = ref<DemoVideoRecord | null>(null)
const featuredCourse = courseVideos[0]!
const additionalCourses = courseVideos.slice(1).filter((video): video is DemoVideoRecord => Boolean(video))
</script>

<template>
  <div class="course-gallery-page">
    <SiteHeader />
    <main class="course-gallery-main">
      <div class="course-gallery-shell">
        <header class="course-gallery-intro">
          <h1>AIGC 创作课堂</h1>
          <p>从策划、拍摄到生成交付，按项目学习</p>
        </header>

        <section class="course-featured" :aria-labelledby="`course-${featuredCourse.id}`">
          <button
            type="button"
            class="course-featured-media"
            :aria-label="`播放试看：${featuredCourse.title}`"
            @click="activeVideo = featuredCourse"
          >
            <img :src="featuredCourse.poster" :alt="`${featuredCourse.title} 课程封面`" />
            <span class="course-media-shade" aria-hidden="true"></span>
            <span class="course-media-play" aria-hidden="true">
              <Play :size="27" fill="currentColor" />
            </span>
          </button>
          <div class="course-featured-copy">
            <h2 :id="`course-${featuredCourse.id}`">{{ featuredCourse.title }}</h2>
            <span class="course-duration">{{ featuredCourse.duration }}</span>
            <ul class="course-facts">
              <li>适合品牌短片策划</li>
              <li>含完整案例讲解</li>
            </ul>
            <p>详解品牌视频从策划、拍摄到交付的完整方法，结合真实镜头与项目流程，帮助你建立清晰的内容制作思路。</p>
            <button type="button" class="course-feature-action" @click="activeVideo = featuredCourse">
              <Play :size="17" fill="currentColor" aria-hidden="true" />
              播放试听
            </button>
          </div>
        </section>

        <section class="course-library" aria-labelledby="course-library-title">
          <h2 id="course-library-title">全部课程</h2>
          <div class="course-library-list">
            <article v-for="video in additionalCourses" :key="video.id" class="course-list-card">
              <button type="button" class="course-list-media" :aria-label="`播放试看：${video.title}`" @click="activeVideo = video">
                <img :src="video.poster" :alt="`${video.title} 课程封面`" />
                <span class="course-list-play" aria-hidden="true"><Play :size="21" fill="currentColor" /></span>
              </button>
              <div class="course-list-copy">
                <h3>{{ video.title }}</h3>
                <span class="course-duration">{{ video.duration }}</span>
                <p>通过理论讲解与实操演示，从用光到构图了解拍摄方法、镜头设计与项目流程。</p>
              </div>
              <button type="button" class="course-list-action" @click="activeVideo = video">
                <Play :size="16" fill="currentColor" aria-hidden="true" />
                播放试听
              </button>
            </article>
            <div class="course-coming-soon" role="status">更多课程将陆续更新</div>
          </div>
        </section>
      </div>
    </main>
    <SiteFooter />
    <VideoLightbox :video="activeVideo" @close="activeVideo = null" />
  </div>
</template>
